import { useAppAuth } from "@contexts/AuthContext";
import { useParams } from "react-router-dom";
import VisualizarSolicitacao from "./Visitante/Index";
import { perfisAdmin, perfisUnidadeGerencia, perfisVisitante } from "@utils/auth/perfis";
import ConsultarSolicitacoes from "./Admin/Consultar/Index";
import ConsultarSolicitacoesUnidadeGerencia from "./User/Consultar/Index";

export default function ConsultarSolicitacoesRoleSwitch() {
  const { id } = useParams();
  const { role } = useAppAuth();

  if (perfisAdmin.includes(role)) return <ConsultarSolicitacoes id={id} />;
  if (perfisUnidadeGerencia.includes(role)) return <ConsultarSolicitacoesUnidadeGerencia id={id} />;
  if (perfisVisitante.includes(role)) return <VisualizarSolicitacao id={id} />;
}
